"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateMarketingFreeSettings = exports.UpdateMarketingFreeSettingsActionType = exports.updateMarketingFreeSettings = exports.loadMarketingFreeSettings = exports.FetchMarketingFreeSettings = exports.FetchMarketingFreeSettingsActionType = exports.MarketingFreeSettingsActionType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var MarketingFreeSettingsActionType = (0, _namespacedKeyMirror.default)({
  FETCH_MARKETING_FREE_SETTINGS: null,
  LOAD_MARKETING_FREE_SETTINGS: null,
  UPDATE_MARKETING_FREE_SETTINGS: null
}, _constants.MARKETING_FREE_SETTINGS);
exports.MarketingFreeSettingsActionType = MarketingFreeSettingsActionType;
var FetchMarketingFreeSettingsActionType = (0, _actions.createRequestTypes)(MarketingFreeSettingsActionType.FETCH_MARKETING_FREE_SETTINGS);
exports.FetchMarketingFreeSettingsActionType = FetchMarketingFreeSettingsActionType;
var FetchMarketingFreeSettings = (0, _actions.createRequestActions)(FetchMarketingFreeSettingsActionType);
exports.FetchMarketingFreeSettings = FetchMarketingFreeSettings;
var loadMarketingFreeSettings = (0, _fluxActions.createAction)(MarketingFreeSettingsActionType.LOAD_MARKETING_FREE_SETTINGS);
exports.loadMarketingFreeSettings = loadMarketingFreeSettings;
var updateMarketingFreeSettings = (0, _fluxActions.createAction)(MarketingFreeSettingsActionType.UPDATE_MARKETING_FREE_SETTINGS, (0, _actions.mapPayloadTo)('data'));
exports.updateMarketingFreeSettings = updateMarketingFreeSettings;
var UpdateMarketingFreeSettingsActionType = (0, _actions.createRequestTypes)(MarketingFreeSettingsActionType.UPDATE_MARKETING_FREE_SETTINGS);
exports.UpdateMarketingFreeSettingsActionType = UpdateMarketingFreeSettingsActionType;
var UpdateMarketingFreeSettings = (0, _actions.createRequestActions)(UpdateMarketingFreeSettingsActionType, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateMarketingFreeSettingsActionType.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.sdk.marketingFreeSettings.update.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateMarketingFreeSettingsActionType.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.sdk.marketingFreeSettings.update.failure')));
  }
});
exports.UpdateMarketingFreeSettings = UpdateMarketingFreeSettings;